import React, { useState, useEffect } from "react";

/**
 * SSR で Suspense が使えない（React 17）ため、クライアントでのみ遅延読み込みするラッパー。
 * サーバー・初期クライアント描画では fallback を表示し、マウント後に動的 import でコンポーネントを表示する。
 */
type ClientOnlyLazyProps<P extends Record<string, unknown> = Record<string, unknown>> = {
  load: () => Promise<{ default: React.ComponentType<P> }>;
  fallback: React.ReactNode;
} & P;

export function ClientOnlyLazy<P extends Record<string, unknown> = Record<string, unknown>>({
  load,
  fallback,
  ...props
}: ClientOnlyLazyProps<P>): React.ReactElement {
  const [Component, setComponent] = useState<React.ComponentType<P> | null>(null);

  useEffect(() => {
    load().then((m) => setComponent(() => m.default));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- load は実質不変のため依存から除外
  }, []);

  if (typeof window === "undefined" || !Component) {
    return <>{fallback}</>;
  }
  return <Component {...(props as P)} />;
}
